import { render, staticRenderFns } from "./add-project.vue?vue&type=template&id=c523ef3a&scoped=true&"
import script from "./add-project.vue?vue&type=script&lang=js&"
export * from "./add-project.vue?vue&type=script&lang=js&"
import style0 from "./add-project.vue?vue&type=style&index=0&id=c523ef3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c523ef3a",
  null
  
)

export default component.exports